import { render, staticRenderFns } from "./modalAddBusinessNews.vue?vue&type=template&id=6a1cb136&"
import script from "./modalAddBusinessNews.vue?vue&type=script&lang=js&"
export * from "./modalAddBusinessNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports